/* Component in IndexShots to display each the IndexShot
 * Contains a link to IndexShotsFullSize to view the Image full size
 * Contains the IndexShotEdit component */
import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Card from "react-bootstrap/Card"
// import { useHistory } from "react-router-dom"
// import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
// import { PostDropdown } from "../../components/PostDropdown"
import styles from "../../styles/Indexes.module.css"
// import IndexShotEdit from "./IndexShotEdit"
// import useHostName from "../../hooks/useHostName"
// import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
// import { useCurrentUser } from "../../contexts/CurrentUserContext"
// import toast from "react-hot-toast";

const IndexShot2 = (props) => {
  // const host = useHostName()
  // const [showEdit, setShowEdit] = useState(false)
  // const history = useHistory();
  const { image, shot } = props
  // const currentUser = useCurrentUser()

  // const handleEdit = () => {
  //   setShowEdit(true)
  // }

  // const handleDelete = async () => {
  //   try {
  //     if (host === CLIENT_PROGRAM_HOSTNAME) {
  //       await axiosReq.delete(`/indexshots/${id}/`)
  //       toast.success(`Indexshot Deleted`);
  //       setHasOrder(true)
  //     } else {
  //       await axiosInstance.delete(
  //         `${localStorage.getItem("projectSlug")}/indexshots/${id}/`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  //           },
  //           withCredentials: true,
  //         }
  //       )
  //       toast.success(`Indexshot Deleted Successfully!`);
  //       setHasOrder(true)
  //     }
  //   } catch (err) { }
  // }

  // const handleClickFull = () => {
  //       // setImage(image); 
  //       history.push(`/${localStorage.getItem("projectSlug")}/indexshots/fullsize/${id}`);  
  //     };

  const [contentType, setContentType] = useState(null);

  const isImageFile = (fileType) => {
    const acceptedImageTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/bmp",
      "image/webp",
      "image/tiff",
      "image/svg+xml",
    ];
    return acceptedImageTypes.includes(fileType);
  };

  const getContentTypeWithGET = async (url) => {
    try {
      const res = await fetch(url, { method: "GET", cache: "no-store" });
      return res.headers.get("Content-Type");
    } catch (err) {
      console.error("Error fetching content type:", err);
      return null;
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps -- re-fetch only when shot image ref changes
  useEffect(() => {
    if (shot?.image) {
      getContentTypeWithGET(image).then(setContentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shot?.image]);

  return (
    <div className='mt-3 px-3'>
      <Row>
        <Col className="mt-0 p-0 text-center" xs={12}>
          {shot?.image && contentType && (
            <>
              {isImageFile(contentType) ? (
                <figure className="m-0 px-0 text-center">
                  <Card.Img
                    className={`${styles.ImagesIndex} rounded`}
                    src={shot.image}
                    alt="shot"
                  />
                </figure>
              ) : contentType === "application/pdf" ? (
                <iframe
                  src={shot.image}
                  allow="fullscreen"
                  title="pdf"
                  width="90%"
                  height="235"
                  style={{ border: "1px solid #ccc" }}
                />
              ) : (
                <p>Unsupported file type: {contentType}</p>
              )}
            </>)}
        </Col>
      </Row>
    </div>
  )
}
export default IndexShot2
